import React from 'react';
import {Avatar, Button, RichCell} from '@vkontakte/vkui';
import {Icon20DeleteOutline} from '@vkontakte/icons';
import {AdaptivityContext} from '../assets/constants';
import * as constants from '../assets/constants';

function pickFirstImage(point, images_url) {
    let image_item = {
        hasImage: false,
        mainImage: images_url + constants.EMPTY_IMG,
        thumb: images_url + constants.EMPTY_IMG,
    };
    if (Array.isArray(point.images)) {
        point.images.forEach((img) => {
            if (img.hasImage && !image_item.hasImage) {
                image_item = {...img, hasImage: true};
            }
        });
    }
    return image_item;
}

function makeAbsoluteUrl(images_url, src) {
    const cleaned = src
        .replace('https:/l', 'https://l')
        .replace('https://lab.scladro.ru', '')
        .replace(images_url, '');
    return images_url + cleaned;
}

function withTimestamp(url, ts) {
    return url + (url.includes('?') ? '&t=' + ts : '?t=' + ts);
}

/**
 * Строка списка торговых точек: клик по строке открывает форму;
 * миниатюра не кликабельна; кнопка удаления — только для ответственного.
 */
export default function SalePointListRow({
    point,
    index,
    rowStyle,
    types,
    images_url,
    galleryTimestamp,
    isTradeChild,
    onOpen,
    onDelete,
}) {
    const stopPropagation = (e) => {
        e.stopPropagation();
    };

    const image_item = pickFirstImage(point, images_url);
    const thumbUrlTs = withTimestamp(
        makeAbsoluteUrl(images_url, image_item.thumb),
        galleryTimestamp,
    );

    const managerTitle = point.manager ? point.manager.title : 'Не указан';
    const klientTitle = (point.klient && point.klient.title)
        || point.klient_title
        || point.client_title
        || '';
    const mallTitle = point.mall ? point.mall.title : '';
    const closedAt = point.closed_at || '';
    const closedBy = point.closed_by_name
        || (point.closed_by_user && point.closed_by_user.title)
        || '';
    const isClosed = point.closed == 1;

    const handleDelete = (e) => {
        stopPropagation(e);
        onDelete(point, index);
    };

    return (
        <RichCell
            onClick={() => onOpen(point)}
            before={
                <Avatar
                    mode="image"
                    style={{borderRadius: '5%', pointerEvents: 'none'}}
                    size={AdaptivityContext.isMobile ? 50 : 100}
                    src={thumbUrlTs}
                />
            }
            subhead={`${mallTitle ? mallTitle + ', ' : ''}${point.full_address || 'Адрес не указан'}`}
            multiline
            style={{...rowStyle, cursor: 'pointer'}}
            caption={
                <div>
                    {klientTitle && <div>Контрагент: <b>{klientTitle}</b></div>}
                    <div>Ответственный: <b>{managerTitle}</b></div>
                    <div>Тип ТТ: <b>{types[point.type_] || 'Не указан'}</b></div>
                    {isClosed && (
                        <div style={{color: '#8a5c64'}}>
                            Закрыта: <b>{closedAt}{closedBy ? ', ' + closedBy : ''}</b>
                        </div>
                    )}
                </div>
            }
            afterCaption={isTradeChild ? (
                <div onClick={stopPropagation}>
                    <Button mode="secondary" onClick={handleDelete} size="s">
                        <Icon20DeleteOutline/>
                    </Button>
                </div>
            ) : null}
        >
            {point.title || 'Без вывески'}{point.trading_floor ? ', Зал: ' + point.trading_floor : ''}
        </RichCell>
    );
}
